export const TOKEN_KEY = "@geriox-passport";
export const TYPE_USER = "@type";

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;

export const getToken = () => {
	const passport = JSON.parse(localStorage.getItem(TOKEN_KEY));
	const expiresPassport = new Date(passport.expires_in).getTime();
	const dataNow = new Date().getTime();

	if (expiresPassport > dataNow) {
		return passport.token;
	} else {
		logout();
		window.history.go("/");
	}

	return null;
};

export const typeUser = () => localStorage.getItem(TYPE_USER);

export const login = (token, type) => {
	localStorage.setItem(TOKEN_KEY, token);
	localStorage.setItem(TYPE_USER, type);
};

export const logout = () => {
	localStorage.removeItem(TOKEN_KEY);
	localStorage.removeItem(TYPE_USER);
	localStorage.removeItem("@profile");
};
